import type { CompanyProfile, CompanyProfileUpdate } from "plg/types";
import { plgRequest } from "plg/api/plgApi";
import { getPlgProfile } from "plg/auth/plgTokenStore";
import { toApiResult } from "util/apiError";
import type { ApiResult } from "util/apiError";

export async function fetchCompanyProfile(): Promise<CompanyProfile> {
  const { ok, status, payload } = await plgRequest<CompanyProfile>("GET", "/v1/plg/company");
  if (!ok) throw new Error(`Failed to load company profile: ${status}`);
  return payload;
}

export async function updateCompanyProfile(body: CompanyProfileUpdate): Promise<ApiResult<CompanyProfile>> {
  const res = toApiResult<CompanyProfile>(await plgRequest("PATCH", "/v1/plg/company", body));
  if (res.ok) toolsCache = null; // the tools may have changed
  return res;
}

let toolsCache: { customerId: string; tools: Promise<string[]> } | null = null;

/**
 * The customer's own tools (sign-up / Company page), for the tool chips and "Knows X, like your team".
 * Loaded once per PLG customer; [] when unavailable.
 */
export function fetchCompanyTools(): Promise<string[]> {
  const customerId = getPlgProfile()?.plgCustomerId || "";
  if (!toolsCache || toolsCache.customerId !== customerId) {
    toolsCache = {
      customerId,
      tools: fetchCompanyProfile()
        .then((p) => (Array.isArray(p.tools) ? p.tools : []))
        .catch(() => {
          toolsCache = null; // a later screen tries again
          return [];
        }),
    };
  }
  return toolsCache.tools;
}
